<template>
  <div :class="b()" :style="styleSizeName">
    <div ref="pager" :class="b('pager')" :style="pagerStyle">
      <div :class="b('pager__text')">
        <div :style="pagerPrefixStyle" v-if="pagerPrefixUrl">
          <img :src="pagerPrefixUrl" alt style="width: 100%;" />
        </div>
        <span @click="goLink(pagerTitle)">{{ pagerTitle }}</span>
        <span v-if="hasPager">({{ dataChart.total }})</span>
      </div>
      <div :class="b('pager__btn')" v-if="hasPager">
        <div class="entSwiper-num">
          <span class="entcurrent">{{ page }}</span
          >/
          <span class="enttotal">{{ totalPage }}</span>
        </div>
        <div :class="b('pager__btn--pre')" :style="pagerBtnStyle" @click="pageClick('pre')"></div>
        <div :class="b('pager__btn--next')" :style="pagerBtnStyle" @click="pageClick('next')"></div>
      </div>
    </div>
  </div>
</template>
<script>
import init from '@/mixins/chart';
export default {
  name: 'pager',
  mixins: [init],
  data() {
    return {
      page: 1
    };
  },
  props: {
    option: Object,
    component: Object
  },
  computed: {
    pagerTitle() {
      return this.option.pagerTitle;
    },
    totalPage() {
      let { total, pageTotal = 0 } = this.dataChart;
      let pageSize = this.dataQuery[this.option.pageSize] || 1;
      (total == null || total == '') && (pageTotal = 0);
      pageSize != 0 && total % pageSize == 0 && (pageTotal = parseInt(total / pageSize));
      pageSize != 0 && total % pageSize != 0 && (pageTotal = parseInt(total / pageSize) + 1);
      return pageTotal;
    },
    hasPager() {
      return this.option.hasPager && this.dataChart.total;
    },
    pagerPrefixUrl() {
      return this.option.pagerPrefixUrl;
    },
    pagerPrefixStyle() {
      return {
        width: this.setPx(this.option.pagerPrefixSize),
        height: this.setPx(this.option.pagerPrefixSize),
        marginRight: this.setPx(this.option.pagerPrefixSplit)
      };
    },
    pagerStyle() {
      return {
        fontWeight: this.option.pagerFontWeight || 'normal',
        fontSize: this.setPx(this.option.pagerFontSize),
        color: this.option.pagerColor || '#fff'
      };
    },
    pagerBtnStyle() {
      return {
        width: this.setPx(this.option.pagerBtnSize),
        height: this.setPx(this.option.pagerBtnSize),
        background: this.option.pagerBtnBgc || '#3563aa'
      };
    }
  },
  methods: {
    pageClick(type) {
      if (type === 'pre') {
        if (this.page > 1) {
          this.page--;
          this.click({
            type: this.name,
            child: this.child,
            value: this.page
          });
        }
      } else {
        if (this.page < this.totalPage) {
          this.page++;
          this.click({
            type: this.name,
            child: this.child,
            value: this.page
          });
        }
      }
    },
    goLink(pagerTitle) {
      console.log('我是点击事件');
      this.progressClick({ pagerTitle: pagerTitle });
    }
  }
};
</script>

<style lang="scss" scoped>
.avue-echart-pager {
  &__pager {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: none;
    &__text {
      display: flex;
    }
    &__btn {
      position: relative;
      min-width: 100px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      &--pre,
      &--next {
        outline: none;
        width: 22px;
        height: 22px;
        border-radius: 2px;
        background: #3563aa;
        text-align: center;
        line-height: 22px;
        top: 0;
        margin: 0 5px;
        position: relative;
        cursor: pointer;
        &::after {
          content: '';
          font-size: 10px;
          width: 0;
          height: 0;
          border-top: 0.8em solid transparent;
          border-bottom: 0.8em solid transparent;
          position: absolute;
          top: 50%;
          left: 50%;
        }
      }
      &--pre {
        &::after {
          content: '';
          border-right: 0.8em solid #fff;
          border-left: 0.8em solid transparent;
          transform: translate(-75%, -50%);
        }
      }
      &--next {
        &::after {
          content: '';
          border-left: 0.8em solid #fff;
          border-right: 0.8em solid transparent;
          transform: translate(-25%, -50%);
        }
      }
    }
  }
}
</style>
